import { FINANCE_NAVIGATION_URL } from '../constants/bottomNavigationBar.js';
import { NF_SERVICE_TYPE, NF_SERVICE_INFO } from '../constants/global.js';
import { URL } from '../constants/url.js';
import { GlobalConfig } from '../globalConfig.js';

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isNaverApp = isBrowser && /NAVER\(inapp; search;/.test(navigator.userAgent);
function getServiceHost(serviceType) {
  switch (serviceType) {
    case NF_SERVICE_TYPE.MY_ASSET:
    case NF_SERVICE_TYPE.PAYMENT:
    case NF_SERVICE_TYPE.FINANCE:
      return GlobalConfig.payDomain;
    case NF_SERVICE_TYPE.STOCK:
      return GlobalConfig.stockDomain;
    case NF_SERVICE_TYPE.REAL_ESTATE:
      return GlobalConfig.realEstateDomain;
  }
}
function getServiceUrl(serviceType) {
  switch (serviceType) {
    case NF_SERVICE_TYPE.MY_ASSET:
    case NF_SERVICE_TYPE.PAYMENT:
    case NF_SERVICE_TYPE.FINANCE:
      return getServiceHost(serviceType) + NF_SERVICE_INFO[serviceType].href;
    case NF_SERVICE_TYPE.STOCK:
      return getServiceHost(serviceType) + NF_SERVICE_INFO[serviceType].href;
    case NF_SERVICE_TYPE.REAL_ESTATE:
      return getServiceHost(serviceType) + NF_SERVICE_INFO[serviceType].href;
  }
}
function getFinanceServiceUrl(financeType) {
  return GlobalConfig.payDomain + FINANCE_NAVIGATION_URL[financeType];
}
function getFooterServiceUrl(href) {
  switch (href) {
    case URL.TERMS_POLICY:
    case URL.PRIVACY:
    case URL.CREDIT_INFO_USAGE:
    case URL.LOAN_SOLICITATION_TERMS:
    case URL.NAVER_FINANCIAL_TERMS_POLICY:
      return GlobalConfig.payDomain + href;
    case URL.STOCK.NOTICE:
      return GlobalConfig.stockDomain + href;
    case URL.REAL_ESTATE_OPEN_SOURCE_LICENSE:
      return GlobalConfig.realEstateDomain + href;
    default:
      return href;
  }
}
function injectPackageVersion() {
  if (!isBrowser) {
    throw new Error('injectPackageVersion should be invoked in a Browser.');
  }
  // rollup에 의해 배포될 버전이 inject됩니다.
  var version = "3.4.0";
  window.__DEFIGN_DATA__ = {
    version: version
  };
}

export { getFinanceServiceUrl, getFooterServiceUrl, getServiceHost, getServiceUrl, injectPackageVersion, isBrowser, isNaverApp };
